import PropTypes from 'prop-types';
import { useState } from 'react';

import useCommentIdFromRouterHash from 'hooks/useCommentIdFromRouterHash';

import CommentItem from './Item';
import RepliesList from './RepliesList';

const CommentListItem = ({
  aliasId,
  canBeRecommendedAsReview = true,
  commentDate,
  commentFixed = false,
  commentId,
  commentLikes,
  commentStatusName,
  commentText,
  hashCommentRef,
  isDisliked,
  isEdited,
  isLiked,
  isReply = false,
  isReview = false,
  parentId = null,
  replies,
  userId,
  userLevel,
  userName,
  userPhoto,
  userSpecialtyName = null,
  userTypeName,
  userUsername,
}) => {
  const { commentId: commentIdFromUrlHash } = useCommentIdFromRouterHash();
  const [isShowingReplies, setShowingReplies] = useState(true);

  const hasReply = replies.length > 0;

  return (
    <CommentItem
      ref={commentIdFromUrlHash === commentId ? hashCommentRef : undefined}
      aliasId={aliasId}
      canBeRecommendedAsReview={canBeRecommendedAsReview}
      commentDate={commentDate}
      commentFixed={commentFixed}
      commentId={commentId}
      commentLikes={commentLikes}
      commentStatusName={commentStatusName}
      commentText={commentText}
      hasReply={hasReply}
      isDisliked={isDisliked}
      isEdited={isEdited}
      isLiked={isLiked}
      isReply={isReply}
      isReview={isReview}
      isShowingReplies={isShowingReplies}
      parentId={parentId}
      userId={userId}
      userLevel={userLevel}
      userName={userName}
      userPhoto={userPhoto}
      userSpecialtyName={userSpecialtyName}
      userTypeName={userTypeName}
      userUsername={userUsername}
      onToggleReplies={() => setShowingReplies((prevState) => !prevState)}
    >
      {hasReply && isShowingReplies && (
        <RepliesList
          canCommentsBeRecommendedAsReview={canBeRecommendedAsReview}
          hashCommentRef={hashCommentRef}
          parentId={commentId}
          replies={replies}
        />
      )}
    </CommentItem>
  );
};

CommentListItem.propTypes = {
  aliasId: PropTypes.number,
  canBeRecommendedAsReview: PropTypes.bool,
  commentDate: PropTypes.string.isRequired,
  commentFixed: PropTypes.bool,
  commentId: PropTypes.number.isRequired,
  commentLikes: PropTypes.number.isRequired,
  commentStatusName: PropTypes.string.isRequired,
  commentText: PropTypes.string.isRequired,
  hashCommentRef: PropTypes.shape().isRequired,
  isDisliked: PropTypes.bool.isRequired,
  isEdited: PropTypes.bool.isRequired,
  isLiked: PropTypes.bool.isRequired,
  isReply: PropTypes.bool,
  isReview: PropTypes.bool,
  parentId: PropTypes.number,
  replies: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  userId: PropTypes.number.isRequired,
  userLevel: PropTypes.number.isRequired,
  userName: PropTypes.string.isRequired,
  userPhoto: PropTypes.string.isRequired,
  userSpecialtyName: PropTypes.string,
  userTypeName: PropTypes.string.isRequired,
  userUsername: PropTypes.string.isRequired,
};

export default CommentListItem;
